var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row flex-md-column justify-content-start m-2 m-md-3 p-md-2 mobile-bar"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }